// extracted by mini-css-extract-plugin
export default {"login":"login_login__mjqO8","login_block":"login_login_block__Nmqpt","copyright":"login_copyright__VrYnc"};